import { Link } from "react-router-dom";
import { BUSINESS_INFO, SUPPORT_EMAIL } from "@/lib/site-info";

const BUSINESS_FIELDS: { label: string; value: string }[] = [
  { label: "상호", value: BUSINESS_INFO.companyName },
  { label: "대표", value: BUSINESS_INFO.representative },
  { label: "사업자등록번호", value: BUSINESS_INFO.registrationNumber },
  { label: "통신판매업 신고", value: BUSINESS_INFO.mailOrderNumber },
  { label: "주소", value: BUSINESS_INFO.address },
  { label: "전화", value: BUSINESS_INFO.phone },
];

export function SiteFooter(): JSX.Element {
  const businessFields = BUSINESS_FIELDS.filter((f) => f.value !== "");
  return (
    <footer className="border-t border-border py-8">
      <div className="container space-y-4 text-xs text-muted-foreground">
        <div className="flex flex-col items-center justify-between gap-3 sm:flex-row">
          <p>© 2026 Devit. All rights reserved.</p>
          <nav className="flex flex-wrap justify-center gap-x-4 gap-y-2">
            <Link to="/pricing" className="hover:text-foreground">
              가격
            </Link>
            <Link to="/download" className="hover:text-foreground">
              다운로드
            </Link>
            <Link to="/terms" className="hover:text-foreground">
              이용약관
            </Link>
            <Link to="/privacy" className="font-semibold hover:text-foreground">
              개인정보 처리방침
            </Link>
            <Link to="/refund" className="hover:text-foreground">
              환불 정책
            </Link>
            <Link to="/contact" className="hover:text-foreground">
              문의
            </Link>
          </nav>
        </div>
        {businessFields.length > 0 && (
          <p className="flex flex-wrap justify-center gap-x-3 gap-y-1 sm:justify-start">
            {businessFields.map((f) => (
              <span key={f.label}>
                {f.label} {f.value}
              </span>
            ))}
            <span>이메일 {SUPPORT_EMAIL}</span>
          </p>
        )}
      </div>
    </footer>
  );
}
